import { grey } from "@mui/material/colors";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export function TutorialMachineThirdStepPanel() {
    return (
        <Box sx={{ border: `1px solid ${grey[200]}`, borderRadius: 2, p: 2, backgroundColor: grey[50] }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                <InfoOutlinedIcon sx={{ color: '#1E5139', fontSize: 20 }} />
                <Typography variant="subtitle2" fontWeight={600}>Instruções de Designação:</Typography>
            </Box>
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                {[
                    'Clique em um motor para configurá-lo.',
                    'Motores agrupados aparecem como um único bloco — clique para configurar o grupo.',
                    'Preencha os dados do produto no painel ao lado.',
                    'Use "Bloquear motor" para deixá-lo indisponível na máquina.',
                    'Um motor bloqueado pode ser liberado em "Desbloquear motor".',
                ].map((txt, i) => (
                    <Box component="li" key={i} sx={{ mb: 1 }}>
                        <Typography variant="body2" color="text.secondary">{txt}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}